module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Message ใช้แสดง Content ที่ต้องการดึงความสนใจผู้ใช้และเน้นความรู้สึกต่างๆ\n        เช่น ให้ข้อมูล, แจ้งเตือน, ผิดพลาด เป็นต้น\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Form\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      }
    }
  }, [_vm._v("\n            Progress   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-message"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Message\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(optional)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-close")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        กรณี Content ที่เป็นเพียง Text คุณไม่จำเป็น\n        ต้องใส่ไว้ด้านใน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v(" ก็ได้ แต่เมื่อ Content มี Element อื่นๆ แทรกอยู่\n        คุณจำเป็นจะต้องใส่ Content ทั้งหมด ไว้ด้านใน Element "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")]), _vm._v("\n        เพื่อการแสดงผลที่ถูกต้อง\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-dark")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-message-close")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Message -->\n<div class=\"bio-message\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Basic Message with Closeable -->\n<div class=\"bio-message\">\n  <div class=\"bio-message-close\">\n    <a class=\"bio-link -fancy\" href=\"#\">close</a>\n  </div>\n  <div class=\"bio-message-content\">\n    <strong>Note – </strong> Lorem ipsum dolor sit amet, <u>consectetur</u> adipiscing elit.\n  </div>\n</div>\n\n<!-- Basic Message with Closeable -->\n<div class=\"bio-message\">\n  <div class=\"bio-message-close\">\n    <a class=\"bio-link u-close\" href=\"#\"></a>\n  </div>\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-message _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-message-close"
  }, [_c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-message-content"
  }, [_c('strong', [_vm._v("Note – ")]), _vm._v(" Lorem ipsum dolor sit amet, "), _c('u', [_vm._v("consectetur")]), _vm._v(" adipiscing elit.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-message"
  }, [_c('div', {
    staticClass: "bio-message-close"
  }, [_c('a', {
    staticClass: "bio-link u-close",
    attrs: {
      "href": "#"
    }
  })]), _vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Positive -->\n<div class=\"bio-message -positive\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Negative -->\n<div class=\"bio-message -negative\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Info -->\n<div class=\"bio-message -info\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Warning -->\n<div class=\"bio-message -warning\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>\n\n<!-- Dark -->\n<div class=\"bio-message -dark\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-message -positive _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -negative _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -info _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -warning _mgbt-8px"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-message -dark"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9a47d10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentMessage.vue
// module id = 147
// module chunks = 0